export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/fbf1cfaf74329f9a6a1fed67972e7c52.svg";